import React from "react";
import LightGallery from "lightgallery/react";
import GalleryImage1 from '../../images/GalleryImage1.png';
import GalleryImage2 from '../../images/GalleryImage2.png';
import GalleryImage3 from '../../images/GalleryImage3.png';
import GalleryImage4 from '../../images/GalleryImage4.png';
import GalleryImage5 from '../../images/GalleryImage5.png';
import GalleryImage6 from '../../images/GalleryImage6.png';
import GalleryImage7 from '../../images/GalleryImage7.png';
import GalleryImage8 from '../../images/GalleryImage8.png';
import GalleryImage9 from '../../images/GalleryImage9.png';
import GalleryImage10 from '../../images/GalleryImage10.png'
import favicon from '../../images/logo2.png';

import Navbar from '../Navbar/Navbar';
import Footer from '../Footer/Footer';
import { Helmet } from 'react-helmet';

import "lightgallery/css/lightgallery.css";
import "lightgallery/css/lg-zoom.css";
import "lightgallery/css/lg-thumbnail.css";

import lgThumbnail from "lightgallery/plugins/thumbnail";
import lgZoom from "lightgallery/plugins/zoom";


const Gallery: React.FC = () => {
    return (
        <>
        <Helmet>
        <title>Gypsum Work Gallery | Before & After Interior Transformations</title>
        <meta name="description" content="Explore our gallery showcasing completed gypsum projects. See stunning before-and-after transformations of ceilings, partitions, and decorative interiors. Experience precision, elegance, and modern design in every project." />
        <meta name="keywords" content="gypsum work gallery, completed gypsum projects, before and after gypsum, interior transformations, false ceiling designs, wall partitions, decorative gypsum work, modern interiors, residential gypsum, commercial gypsum" />
        <link rel="icon" href={favicon} type="image/png" />
      </Helmet>
            <Navbar />
            <section id="gallery" className="p-8 bg-gray-50 text-center">
                <h1 className="text-5xl font-bold mb-10">Our Projects</h1>

                <LightGallery speed={500} plugins={[lgThumbnail, lgZoom]}>

                    <div className="flex flex-wrap justify-center gap-4 m-5">
                        <a href="/images/project1.jpg">
                            <img src={GalleryImage6} alt="Image 1"
                                className="w-80 rounded-2xl shadow-md hover:scale-105 transition-transform duration-300" />
                        </a>

                        <a href="/images/project1.jpg">
                            <img src={GalleryImage7} alt="Image 2"
                                className="w-80 rounded-2xl shadow-md hover:scale-105 transition-transform duration-300" />
                        </a>

                        <a href="/images/project1.jpg">
                            <img src={GalleryImage1} alt="Image 3"
                                className="w-80 rounded-2xl shadow-md hover:scale-105 transition-transform duration-300" />
                        </a>

                        <a href="/images/project1.jpg">
                            <img src={GalleryImage2} alt="Image 4"
                                className="w-80 rounded-2xl shadow-md hover:scale-105 transition-transform duration-300" />
                        </a>

                        <a href="/images/project1.jpg">
                            <img src={GalleryImage3} alt="Image 5"
                                className="w-80 rounded-xl shadow-md hover:scale-105 transition-transform duration-300" />
                        </a>

                        <a href="/images/project1.jpg">
                            <img src={GalleryImage4} alt="Image 6"
                                className="w-80 rounded-xl shadow-md hover:scale-105 transition-transform duration-300" />
                        </a>

                        <a href="/images/project1.jpg">
                            <img src={GalleryImage5} alt="Image 7"
                                className="w-80 rounded-xl shadow-md hover:scale-105 transition-transform duration-300" />
                        </a>

                        <a href="/images/project1.jpg">
                            <img src={GalleryImage6} alt="Image8"
                                className="w-80 rounded-xl shadow-md hover:scale-105 transition-transform duration-300" />
                        </a>

                    </div>

                    <div>
                        <h2 className="text-5xl font-bold mt-10 mb-10">Work Transformation</h2>
                        <div className="flex flex-wrap justify-evenly gap-4">
                            <a href="/images/project1.jpg">
                                <img src={GalleryImage8} alt="Image 9"
                                    className="w-96 rounded-xl shadow-md hover:scale-105 transition-transform duration-300" />
                            </a>
                            <p className="text-2xl my-auto font-semibold text-gray-600">Witness the magic of gypsum craftsmanship.
                                <br /> From raw construction to polished perfection. <br />
                                Every corner designed with precision and elegance.</p>
                        </div>

                        <div className="flex flex-wrap justify-evenly gap-4">
                            <p className="text-xl my-auto font-semibold text-gray-600">Before and after – a story of transformation. <br />
                                Smooth ceilings, stylish partitions, and professional finishes.<br />
                                Turning ordinary spaces into extraordinary living areas.</p>

                            <a href="/images/project1.jpg">
                                <img src={GalleryImage10} alt="Image 10"
                                    className="w-96 rounded-xl shadow-md hover:scale-105 transition-transform duration-300" />
                            </a>
                        </div>
                    </div>


                </LightGallery>
            </section>
            <Footer />
        </>


    );
};

export default Gallery;
